export default __webpack_public_path__ + "static/media/StateemblemofPakistan.8bf379c5.svg";